import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import PopoverHeader from './PopoverHeader'
import { connect } from 'react-redux'
import { Label, RadioGroup } from 'wix-style-react'
import { setCustomFieldArray } from 'controllers/logic'

const Container = styled.div`
  _height: 26em;
  width: 20em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border-radius: 8px;
  box-shadow: 0 4px 10px 8px rgba(175,175,175,0.27);
`
const TextInputContainer = styled.div`
  padding: 1.3em 1.5em 1.3em 1.5em;
`
const Content = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  display: flex;
  flex-direction: column;
`

class OptionalBlockPopover extends Component {

  componentWillMount () {
    this.props.updatePosition('15%', '45%')
  }

  onChange = (value) => {
    const { app, dispatch, path } = this.props
    if (path) {
      dispatch(setCustomFieldArray(app.id, path, value))
    }
  }

  renderContent () {
    return (
      <TextInputContainer>
        <div>
          <Label appearance='T1.1' for='email'>
            Choose field type:
          </Label>
          <RadioGroup value={this.props.value} onChange={val => this.onChange(val)} display='horizontal'>
            <RadioGroup.Radio value={'button'}>Button</RadioGroup.Radio>
            <RadioGroup.Radio value={'email'}>Email</RadioGroup.Radio>
            { this.props.app.templateId === 'coffee' &&
              <RadioGroup.Radio value={'appLinks'}>App Links</RadioGroup.Radio>
            }
          </RadioGroup>
        </div>
      </TextInputContainer>
    )
  }

  render () {
    const { app, field, closeMyself } = this.props
    return (
      <Container>
        <PopoverHeader
          headingDescriptor='Email Settings'
          onClose={closeMyself}
          app={app}
          helpTooltip=''
          field={field}
        />
        <Content>
          {this.renderContent()}
        </Content>
      </Container>
    )
  }
}

OptionalBlockPopover.propTypes = {
  closeMyself: PropTypes.func,
  value: PropTypes.string,
  path: PropTypes.array,
  // title: PropTypes.string,
  field: PropTypes.object.isRequired,
  app: PropTypes.object.isRequired,
  updatePosition: PropTypes.func,
}

export default connect()(OptionalBlockPopover)



// WEBPACK FOOTER //
// ./src/components/editor/popovers/OptionalBlockPopover.js